(function () {
  var root = document.querySelector('.gp');

  if (!root) {
    return;
  }

  // =========================
  // Mobile Menu
  // =========================

  var burger = root.querySelector('[data-burger]');
  var nav = root.querySelector('[data-nav]');

  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('open');

      burger.setAttribute(
        'aria-expanded',
        open ? 'true' : 'false'
      );
    });

    nav.addEventListener('click', function (e) {
      if (e.target.tagName === 'A') {
        nav.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // =========================
  // Carousels
  // =========================

  function scrollCarousel(id, direction) {
    var target = document.getElementById(id);

    if (!target) {
      return;
    }

    var first = target.firstElementChild;

    var step = first
      ? first.getBoundingClientRect().width + 14
      : target.clientWidth;

    if (target.classList.contains('track')) {
      step = target.clientWidth;
    }

    target.scrollBy({
      left: direction * step,
      behavior: 'smooth'
    });
  }

  root.querySelectorAll('[data-prev]').forEach(function (button) {
    button.addEventListener('click', function () {
      scrollCarousel(button.dataset.prev, -1);
    });
  });

  root.querySelectorAll('[data-next]').forEach(function (button) {
    button.addEventListener('click', function () {
      scrollCarousel(button.dataset.next, 1);
    });
  });

  // =========================
  // FAQ Accordion
  // =========================

//   root.querySelectorAll('[data-faq] .faq__item').forEach(function (item) {
//   var question = item.querySelector('.faq__q');
//   var answer = item.querySelector('.faq__a');

//   if (!question || !answer) {
//     return;
//   }

//   if (item.classList.contains('open')) {
//     answer.style.maxHeight = answer.scrollHeight + 'px';
//     question.setAttribute('aria-expanded', 'true');
//   } else {
//     question.setAttribute('aria-expanded', 'false');
//   }

//   question.addEventListener('click', function () {
//     var isCurrentlyOpen = item.classList.contains('open');

//     // Close all other FAQ items
//     root.querySelectorAll('[data-faq] .faq__item.open').forEach(function (otherItem) {
//       if (otherItem !== item) {
//         otherItem.classList.remove('open');

//         var otherQuestion = otherItem.querySelector('.faq__q');
//         var otherAnswer = otherItem.querySelector('.faq__a');

//         if (otherQuestion) {
//           otherQuestion.setAttribute('aria-expanded', 'false');
//         }

//         if (otherAnswer) {
//           otherAnswer.style.maxHeight = '0';
//         }
//       }
//     });

//     // Toggle the clicked item
//     if (isCurrentlyOpen) {
//       item.classList.remove('open');
//       question.setAttribute('aria-expanded', 'false');
//       answer.style.maxHeight = '0';
//     } else {
//       item.classList.add('open');
//       question.setAttribute('aria-expanded', 'true');
//       answer.style.maxHeight = answer.scrollHeight + 'px';
//     }
//   });
// });

root.querySelectorAll('[data-faq] .faq__item').forEach(function (item) {

  var question = item.querySelector('.faq__q');
  var answer = item.querySelector('.faq__a');

  if (!question || !answer) {
    return;
  }

  if (item.classList.contains('open')) {
    answer.style.maxHeight = answer.scrollHeight + 'px';
    question.setAttribute('aria-expanded', 'true');
  } else {
    answer.style.maxHeight = '0px';
    question.setAttribute('aria-expanded', 'false');
  }

  question.addEventListener('click', function () {

    var isCurrentlyOpen = item.classList.contains('open');

    // Close all other FAQ items
    root.querySelectorAll('[data-faq] .faq__item.open').forEach(function (otherItem) {

      if (otherItem === item) {
        return;
      }

      otherItem.classList.remove('open');

      var otherQuestion = otherItem.querySelector('.faq__q');
      var otherAnswer = otherItem.querySelector('.faq__a');

      if (otherQuestion) {
        otherQuestion.setAttribute('aria-expanded', 'false');
      }

      if (otherAnswer) {
        otherAnswer.style.maxHeight = '0px';
      }
    });

    // Toggle current FAQ
    if (isCurrentlyOpen) {

      item.classList.remove('open');
      question.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = '0px';

    } else {

      item.classList.add('open');
      question.setAttribute('aria-expanded', 'true');
      answer.style.maxHeight = answer.scrollHeight + 'px';

    }
  });

});

  // =========================
  // Availability Popup
  // =========================

  var popup = root.querySelector('[data-gp-popup]');
  var popupClose = root.querySelector('[data-gp-popup-close]');
  var popupTriggers = root.querySelectorAll('[data-gp-popup-open]');

  if (popup) {

    function openPopup() {
      popup.hidden = false;

      requestAnimationFrame(function () {
        popup.classList.add('is-open');
        document.body.classList.add('gp-popup-lock');
      });
    }

    function closePopup() {
      popup.classList.remove('is-open');
      document.body.classList.remove('gp-popup-lock');

      window.setTimeout(function () {
        popup.hidden = true;
      }, 350);
    }

    // Open popup when Contact A Specialist is clicked

    popupTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        openPopup();
      });
    });

    // Close button

    if (popupClose) {
      popupClose.addEventListener('click', function () {
        closePopup();
      });
    }

    // Close when clicking outside popup

    popup.addEventListener('click', function (e) {
      if (e.target === popup) {
        closePopup();
      }
    });

    // Close with ESC

    document.addEventListener('keydown', function (e) {
      if (
        e.key === 'Escape' &&
        popup.classList.contains('is-open')
      ) {
        closePopup();
      }
    });
  }


// =====================================
// New Arrivals - Side Image Sync
// =====================================

var arrivalsTrack = root.querySelector('#arrivals-track');
var arrivalsSideImage = root.querySelector('#arrivals-side-image');

if (arrivalsTrack && arrivalsSideImage) {

  var arrivalSlides = arrivalsTrack.querySelectorAll('.slide');

  function updateArrivalsSideImage(slide) {

    if (!slide) {
      return;
    }

    var newImage = slide.getAttribute('data-side-image');

    if (!newImage) {
      return;
    }

    // Do NOT modify the URL.
    // It is already a Shopify CDN URL from Liquid.
    if (arrivalsSideImage.getAttribute('src') === newImage) {
      return;
    }

    arrivalsSideImage.style.opacity = '0';

    setTimeout(function () {

      arrivalsSideImage.src = newImage;

      arrivalsSideImage.onload = function () {
        arrivalsSideImage.style.opacity = '1';
      };

      arrivalsSideImage.onerror = function () {
        arrivalsSideImage.style.opacity = '1';
        console.error('Failed to load arrivals side image:', newImage);
      };

    }, 150);
  }

  var arrivalsObserver = new IntersectionObserver(function (entries) {

    var activeSlide = null;
    var highestRatio = 0;

    entries.forEach(function (entry) {

      if (
        entry.isIntersecting &&
        entry.intersectionRatio > highestRatio
      ) {
        highestRatio = entry.intersectionRatio;
        activeSlide = entry.target;
      }

    });

    if (activeSlide) {
      updateArrivalsSideImage(activeSlide);
    }

  }, {
    root: arrivalsTrack,
    threshold: [0.5, 0.75, 1]
  });

  arrivalSlides.forEach(function (slide) {
    arrivalsObserver.observe(slide);
  });

  // Initial image
  if (arrivalSlides.length) {
    updateArrivalsSideImage(arrivalSlides[0]);
  }
}

// =====================================
// Brand Logo Continuous Scroll
// =====================================

var brandsTrack = root.querySelector('.brands-track');

if (brandsTrack) {

  var originalBrands = Array.from(
    brandsTrack.querySelectorAll('.brand')
  );

  if (originalBrands.length) {

    // Duplicate the complete set
    originalBrands.forEach(function (brand) {
      brandsTrack.appendChild(brand.cloneNode(true));
    });

    var brandsPosition = 0;
    var brandsSpeed = 2;
    var originalWidth = 0;

    function calculateBrandsWidth() {
      var totalWidth = 0;

      originalBrands.forEach(function (brand) {
        totalWidth += brand.offsetWidth;
      });

      var gap = parseFloat(
        getComputedStyle(brandsTrack).gap || 0
      );

      totalWidth += gap * (originalBrands.length - 1);

      originalWidth = totalWidth;
    }

    calculateBrandsWidth();

    window.addEventListener('resize', function () {
      calculateBrandsWidth();
    });

    function animateBrands() {

      brandsPosition -= brandsSpeed;

      if (Math.abs(brandsPosition) >= originalWidth) {
        brandsPosition = 0;
      }

      brandsTrack.style.transform =
        'translate3d(' +
        brandsPosition +
        'px, 0, 0)';

      requestAnimationFrame(animateBrands);
    }

    animateBrands();
  }
}

// =========================
// Smooth Scroll - Menu + Buttons
// =========================

root.querySelectorAll('a[href^="#"]').forEach(function (link) {

  link.addEventListener('click', function (e) {

    var targetId = link.getAttribute('href');

    if (
      !targetId ||
      targetId === '#' ||
      targetId.length < 2
    ) {
      return;
    }

    var target = document.querySelector(targetId);

    if (!target) {
      return;
    }

    e.preventDefault();

    var headerOffset = 0;

    window.scrollTo({
      top: target.getBoundingClientRect().top +
           window.pageYOffset -
           headerOffset,
      behavior: 'smooth'
    });

  });

});

})();